export const REPORT_TYPE_POST = 'post';
export const REPORT_TYPE_PHOTO = 'photo';
export const REPORT_TYPE_CAPTION = 'caption';
export const REPORT_TYPE_COMMENT = 'comment';
export const REPORT_TYPE_PROFILE = 'profile';
export const EDIT_POST = 'edit';
export const REMOVE_PHOTO = 'remove_photo';
export const REMOVE_POST = 'remove_post';
